import React from 'react';
import styles from '../../Accounting.module.css';

const HowItWorks = () => (
  <section className={styles.sec} id="how">
    <div className={styles.container}>
      <div className={`${styles.secHead} ${styles.secHeadCenter} ${styles.sr}`} data-sr>
        <span className={styles.eyebrow}><span className={styles.dot} />How it works</span>
        <h2>No data entry required.</h2>
        <p className={styles.secLead}>Your invoices and payments become organized records on their own — no spreadsheets to maintain.</p>
      </div>
      <div className={styles.steps}>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>01</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 3v13m0 0-4-4m4 4 4-4M5 21h14" />
            </svg>
          </div>
          <h3>Income flows in</h3>
          <p>Every paid invoice and payment is recorded automatically — with fees and receipts attached.</p>
        </div>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>02</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 21h18M5 21V10M19 21V10M3 10l9-6 9 6" />
            </svg>
          </div>
          <h3>Add expenses &amp; connect your bank</h3>
          <p>Upload receipts and link your bank account so every cost is tracked right next to your income.</p>
        </div>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>03</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2l2.2 5.8L20 10l-5.8 2.2L12 18l-2.2-5.8L4 10l5.8-2.2z" />
            </svg>
          </div>
          <h3>AI gets you tax-ready</h3>
          <p>AI categorizes everything and flags what matters, so tax season is a quick export — not a scramble.</p>
        </div>
      </div>
    </div>
  </section>
);

export default HowItWorks;
